function formatNumberWithDecimalPlaces(num: number | undefined, digits = 2) {
  if (num && num % 1 === 0 && !digits) {
    return num.toString();
  } else {
    return num?.toFixed(digits);
  }
}

export { formatNumberWithDecimalPlaces };
